import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { map } from "rxjs";
import { ROUTE } from "../../../shared/utils/routes";
import { AuthService } from "../../services/auth/auth.service";

export function authenticatedGuardBuilder({
  mustBeAuthenticated
}: {
  mustBeAuthenticated: boolean;
}): CanActivateFn {
  return () => {
    const router = inject(Router);

    return inject(AuthService)
      .isAuthenticated$()
      .pipe(
        map((isAuthenticated) => {
          const canActivate = mustBeAuthenticated
            ? isAuthenticated
            : !isAuthenticated;
          const redirectRoute = mustBeAuthenticated
            ? ROUTE.AUTHENTICATION
            : ROUTE.AUTHENTICATED;

          if (!canActivate) {
            return router.parseUrl(redirectRoute);
          }

          return true;
        })
      );
  };
}
